import { render } from "./marcaslineas.vue?vue&type=template&id=89b20180&scoped=true"
import script from "./marcaslineas.vue?vue&type=script&lang=js"
export * from "./marcaslineas.vue?vue&type=script&lang=js"

import "./marcaslineas.vue?vue&type=style&index=0&id=89b20180&scoped=true&lang=css"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b20180"]])

export default __exports__